module.exports = __webpack_public_path__ + "img/mp1.44751687.png";